module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-36x36.png";